import React, { useEffect, useState, useRef } from "react"
import Box from "@mui/material/Box"
import { useInfoStore } from "../../store/userInfo";
import { List, ListItem, Stack, Typography } from "@mui/material";
import { TimerState, useMenuStore } from "../../store/menuState";
import { ICategory } from "../../types/menu";
// import arrow from '../../assets/images/scroll_arrow.svg';
import { useTranslation } from "react-i18next";
// import { isBrowser } from 'react-device-detect';
import { useWindowDimensions } from "../../App";
import { useOrderStore } from "../../store/order";
import Logo from "../../components/Logo";
import { useAnalytics } from "../../analytics/AnalyticsContext";
import { logger } from "../../utils/logger";


interface IMenu {
  id: number;
  index: number;
}

const Category = () => {
  const { userInfo, currentLng } = useInfoStore();
  const { height, orientation } = useWindowDimensions();
  const {t} =  useTranslation(`${userInfo?.storeId}`)
  const { setSelectedCategory, fetchCategories, isNativeFlag } = useMenuStore();
  const { setSnackMode, setShowSnackbar, setLimitValue } = useOrderStore();
  const { recordEvent } = useAnalytics();
  const [end, setEnd] = useState(false);
  const selectedMenu = useMenuStore((state) => state.selectedMenu)
  const categories = useMenuStore((state) => state.categories)
  const selectedCategory = useMenuStore((state) => state.selectedCategory)
  const listRef = useRef<HTMLUListElement>(null);
  const landMode = (orientation === "landscape") ?true: false
  // console.log(landMode)
  useEffect(() => {
    if (selectedMenu &&  selectedMenu.id !== undefined && selectedMenu.id !== 0) {
      const menuId = selectedMenu.id 
      fetchCategories(menuId.toString());
    }
  }, [selectedMenu]);
  
  const handleSelectCategory = (item: ICategory) => {
    logger.log(item)
    if(item.timeoutId || (item.timerCategoryId !== undefined && item.timerCategoryId === item.id)) {
      setLimitValue(item.orderIntervalMinutes)
      setSnackMode(9)
      setShowSnackbar(true)
      // return;
    }
    setSelectedCategory(item)

    // Pinpoint 이벤트 기록
    if (!isNativeFlag) {
      recordEvent('category_click', true, {
        categoryId: item.id,
        categoryName: t(`categoryNames.${item.id}.${currentLng}`),
        categoryIndex: item.index,
        isTimeout: Boolean(item.timeoutId),
        isTimerCategory: Boolean(item.timerCategoryId && item.timerCategoryId === item.id),
        orderIntervalMinutes: item.orderIntervalMinutes || 0,
        maxAllowed: item.maxAllowed || 0,
        isPreventSelection: Boolean(item.isPreventSelection),
        storeId: userInfo?.storeId || 'unknown'
      });
    } else {
      if (window.Android !== undefined)
        window.Android.postMessage(JSON.stringify({ 
          type: 'attr', 
          data: {
            function: 'category_click', 
            categoryId: item.id, 
            categoryName: t(`categoryNames.${item.id}.${currentLng}`), 
            categoryIndex: item.index,
            isTimeout: Boolean(item.timeoutId),
            isTimerCategory: Boolean(item.timerCategoryId && item.timerCategoryId === item.id),
            orderIntervalMinutes: item.orderIntervalMinutes || 0,
            maxAllowed: item.maxAllowed || 0,
            isPreventSelection: Boolean(item.isPreventSelection),
            storeId: userInfo?.storeId || 'unknown'
          } 
        }));
    }

    // List View Smooth Scoll
    setTimeout(() => {
      if(listRef.current){
        const element = document.getElementById(`category-${item.id}`);
        if(element){
          const container = listRef.current;
          const newScrollTop = element.offsetTop - (container.clientHeight / 2) + (element.clientHeight / 2);
          container.scrollTo({ top: newScrollTop, behavior: 'smooth' });
        }
      }
    }, 0);

    // if (!isBrowser) {
    //   if (window.ReactNativeWebView !== undefined) {
    //     window.ReactNativeWebView.postMessage(JSON.stringify({'type': 'play'}));
    //   } else if(window.Android !== undefined) {
    //     window.Android.postMessage(JSON.stringify({'type':'play'}));
    //   }
    // }
  };
  const checkSelectCategory = (item: IMenu) => {
    return selectedCategory?.id !== undefined && item.id === selectedCategory?.id ? true: false
  }

  const onScroll = (event: any) => {
    if (event.target.scrollTop >= 15) {
      setEnd(true)
    } else {
      setEnd(false)
    }
  }

  // const updateArrow = () => {
  //   // console.log(end)
  //   if(end) return {transform: 'rotate(180deg)'}
  //   else return {transform: 'rotate(0deg)'}
  // }

  useEffect(() => {
    const setNativeData = (event: MessageEvent) => {
      logger.log("Raw Event Data:", event.data);
      try {
        const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        logger.log("Parsed Data: time-limit", JSON.stringify(data));
        
        if (data.action === "startPromotionCategorySelect") {
          const promotionCategory =
            categories && categories.length > 0 ? categories[0] : null;
          if (promotionCategory) {
            handleSelectCategory(promotionCategory);
            logger.log("Promotion 액션으로 카테고리 선택:", promotionCategory);
          } else {
            logger.warn("categories가 비어있어 선택할 카테고리가 없습니다");
          }
          logger.log("Promotion Start:", data.action);
        }
      } catch (error) {
        logger.error("Error parsing message:", error, event.data);
      }
    };

    window.addEventListener("message", setNativeData);
    return () => window.removeEventListener("message", setNativeData);
  }, [categories, handleSelectCategory]);
  
  if(!categories) 
  return <Box sx={{ width: '100%' , backgroundColor: '#fff', height: `calc(100% - 1.8rem)`, mt: '1.8rem', borderRadius: '1.5rem 1.5rem 0rem 0rem'}}>
    <Logo />
  </Box>
 
  return (
    <Box sx={{ backgroundColor: '#fff', width: '100%', height: `calc(100% - 1.8rem)`, mt: '1.8rem', borderRadius: '1.5rem 1.5rem 0rem 0rem' }} >
      <Logo />
      <List ref={listRef} sx={{ overflow: 'auto', overflowX: 'hidden',  height: `calc(100% - 13.8rem)`,  justifyContent: 'flex-start',  paddingRight: '.9rem', paddingBottom: '5rem' }}  onScroll={onScroll} >
          {categories.map((item: ICategory, index: number) => {
            return(
              <ListItem key={item.id} id={`category-${item.id}`} sx={[{ flexShrink: 0, p:'1rem 3rem',  alignItems: 'center', mb: '2rem'},
              (item.timeoutId || (item.timerCategoryId !== undefined && item.isPreventSelection)) ? {backgroundColor: '#c5c5c5', borderRadius: '0rem 6rem 6rem 0rem'} : checkSelectCategory(item) ? {backgroundColor: '#F72E13', borderRadius: '0rem 20rem 20rem 0rem'}
                : { py: '1rem'}]} onClick={() => handleSelectCategory(item)}>
                <Stack>
                  <Typography sx={{wordBreak: "break-word", color: checkSelectCategory(item) ? '#fff': '#000', textAlign: 'flex-start', alignItems: 'center', 
                  fontSize: '1.8rem', fontStyle: 'normal', width: landMode? '18.5rem': '17rem', fontWeight: '600', letterSpacing: '-.018rem'}} display="block" >{t(`categoryNames.${item.id}.${currentLng}`)}</Typography>
                </Stack>
              </ListItem>)
            })
          }
      </List>
      {/* <Box sx={{position: 'sticky', bottom: 0, height: '4.4rem', borderRadius: '3rem', backgroundColor: 'rgba(0, 0, 0, 0.7)', p: '1rem 2rem 1rem 2rem', mx: '.5rem',
      gap: '2rem', justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'row'}}>
        <Typography sx={{fontSize: '1.6rem', color: '#fff', fontWeight: '500', textWrap: 'nowrap',}}>Scroll for more</Typography>
        <img style={{ marginLeft: '.5rem', width: '2rem', height: '2rem', ...updateArrow()}}
          src={process.env.PUBLIC_URL+'/assets/images/scroll_arrow.svg'}
          alt="arrow"
        />
      </Box> */}
    </Box>
  )
}
// const styles = {
//   bottom: {
//     marginLeft: 5,
//   },
//   // bottomRotate: {
//   //   marginLeft: 5,
//   //   width: 18,
//   //   height: 18,
//   //   transform: [{rotate: '180deg'}],
//   // }
// };
export default Category


